var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeTheme as changeThemeAction } from "../../actions/creators/theme";
import Settings from "./settings/Settings";
import Locale from "./Locale";
import Info from "./Info";
import { defineMessages, FormattedMessage } from "react-intl";
import InstLogoSvg from "../../assets/img/instagram_logo.svg";
import darkThemeImg from "../../assets/img/moon.svg";
import Switcher from "./Switcher";
var messages = defineMessages({
    main_live_chat: {
        id: "main.live_chat",
        defaultMessage: "Live chat",
    },
    follow_on_instagram: {
        id: "follow.on.instagram",
        defaultMessage: "Следите за конкурсами и бонусами в инстаграм",
    },
    dark_theme: {
        id: "dark.theme",
        defaultMessage: "Тёмная тема",
    },
});
var Sidebar = function (props) {
    var client = props.client, darkTheme = props.darkTheme, settingsIsOpened = props.settingsIsOpened;
    var switcherTxt = _jsx(FormattedMessage, __assign({}, messages.dark_theme));
    var toggledDivClassName = darkTheme
        ? "toggle-div__inner toggled"
        : "toggle-div__inner";
    var cls = settingsIsOpened ? "settings-open" : "settings-close";
    return (_jsx("div", __assign({ id: "sidebar" }, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "wdt_menu" }, { children: [_jsx("button", __assign({ className: "sidebar__online-chat", onClick: function () {
                            return window.jivo_api &&
                                window.jivo_api.open &&
                                window.jivo_api.open();
                        } }, { children: _jsx(FormattedMessage, __assign({}, messages.main_live_chat)) })), _jsxs("ul", __assign({ className: "settings-menu ".concat(cls) }, { children: [_jsx(Info, {}), _jsx(Settings, { settingsIsOpened: settingsIsOpened, toggleSettingsBlock: props.toggleSettingsBlock }), _jsx("li", { children: _jsxs("div", __assign({ className: "dark-theme" }, { children: [_jsx("img", { src: darkThemeImg, alt: "settings" }), _jsx(Switcher, { switcherTxt: switcherTxt, onclick: props.changeThemeAction, class: toggledDivClassName })] })) }), _jsx(Locale, {}), client.country === "KG" && (_jsx("li", { children: _jsx("div", __assign({ className: "menu-instagram" }, { children: _jsxs("a", __assign({ id: "instagram-link", target: "_blank", href: "https://www.instagram.com/fairplay.gold", rel: "noopener noreferrer" }, { children: [_jsx("img", { className: "inst_img", src: InstLogoSvg, alt: "instagram" }), _jsx(FormattedMessage, __assign({}, messages.follow_on_instagram))] })) })) }))] }))] })) }) })));
};
Sidebar.propTypes = {
    client: PropTypes.object.isRequired,
    changeThemeAction: PropTypes.func.isRequired,
    toggleSettingsBlock: PropTypes.func.isRequired,
};
var mapStateToProps = function (state) { return ({
    client: state.application.get("client"),
    darkTheme: state.application.get("darkTheme"),
}); };
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        changeThemeAction: changeThemeAction,
    }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js